import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayOverlayGlowing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 78,
	height: 78,
	viewBox: "0 0 78 78",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_80446_88",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 78,
			height: 78,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M77.9822 0.0178223H0.878662V77.1213H77.9822V0.0178223Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_80446_88)",
			children: [/* @__PURE__ */ _jsx("g", {
				opacity: .8,
				filter: "url(#filter0_f_80446_88)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M63.5659 39.1102C63.5674 39.7342 63.4074 40.3479 63.1015 40.8916C62.7956 41.4354 62.3542 41.8908 61.8202 42.2134L28.7253 62.459C28.1674 62.8007 27.5283 62.9872 26.8742 62.9994C26.22 63.0114 25.5745 62.8487 25.0042 62.528C24.4394 62.2122 23.9689 61.7516 23.6411 61.1937C23.3134 60.6358 23.14 60.0006 23.1391 59.3535V18.8669C23.14 18.2199 23.3134 17.5847 23.6411 17.0268C23.9689 16.4689 24.4394 16.0083 25.0042 15.6925C25.5745 15.3718 26.22 15.209 26.8742 15.2212C27.5283 15.2333 28.1674 15.4198 28.7253 15.7615L61.8202 36.007C62.3542 36.3297 62.7956 36.7851 63.1015 37.3288C63.4074 37.8726 63.5674 38.4863 63.5659 39.1102Z",
					fill: "white"
				})
			}), /* @__PURE__ */ _jsx("path", {
				d: "M62.6644 38.4381C62.6659 39.0502 62.509 39.6523 62.2088 40.1858C61.9087 40.7193 61.4756 41.166 60.9517 41.4826L28.4809 61.3454C27.9335 61.6806 27.3064 61.8637 26.6646 61.8756C26.0228 61.8874 25.3894 61.7278 24.83 61.4131C24.2758 61.1032 23.8142 60.6514 23.4926 60.1041C23.171 59.5567 23.0009 58.9335 23 58.2987V18.5775C23.0009 17.9427 23.171 17.3195 23.4926 16.7721C23.8142 16.2248 24.2758 15.7729 24.83 15.4631C25.3894 15.1484 26.0228 14.9887 26.6646 15.0006C27.3064 15.0125 27.9335 15.1955 28.4809 15.5307L60.9517 35.3935C61.4756 35.7101 61.9087 36.1569 62.2088 36.6904C62.509 37.2238 62.6659 37.8259 62.6644 38.4381Z",
				fill: "#F4F4F4"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_80446_88",
			x: 15.1391,
			y: 7.22052,
			width: 56.4268,
			height: 63.7795,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 4,
					result: "effect1_foregroundBlur_80446_88"
				})
			]
		}) })
	]
});
export default SvgPlayOverlayGlowing;
